import { GatewayLocationModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/locations/models/outputs/gateway-location.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { LocationListNetworkCell } from './location-list-network.cell';
import { LocationListNetworkHeader } from './location-list-network.header';

export const LocationListNetworkColumn: IdentifiedColumnDef<
  GatewayLocationModel,
  GatewayLocationModel['network']
> = {
  enableSorting: false,
  header: LocationListNetworkHeader,
  cell: LocationListNetworkCell,
};
